import { render, staticRenderFns } from "./ErrorMovement.vue?vue&type=template&id=1d594b74&scoped=true&"
import script from "./ErrorMovement.vue?vue&type=script&lang=js&"
export * from "./ErrorMovement.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMovement.vue?vue&type=style&index=0&id=1d594b74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d594b74",
  null
  
)

export default component.exports